import React, { useState, useCallback } from "react";
import CoachMark from "./CoachMark";

// Sequence driver — walks the user through a list of CoachMark
// steps. Each step renders independently (CoachMark handles its
// own target finding + spotlight), this just owns the index.
//
// Props:
//   open:       boolean — controls overall visibility
//   steps:      array of { target, title, body, placement?, accent? }
//   onComplete: () => void
//   onSkip:     () => void
//   h:          theme tokens (used to resolve accent color names)
export default function CoachMarkTour({ open, steps, onComplete, onSkip, h = {} }) {
  const [i, setI] = useState(0);

  const next = useCallback(() => {
    if (!steps?.length) return;
    if (i >= steps.length - 1) onComplete?.();
    else setI(x => x + 1);
  }, [i, steps, onComplete]);

  const back = useCallback(() => setI(x => Math.max(0, x - 1)), []);

  if (!open || !steps?.length) return null;

  const step = steps[Math.min(i, steps.length - 1)];
  // Resolve accent name → actual color from theme. Step authors
  // write 'gn' / 'ac' / 'pp' / 'wn' (semantic theme tokens) so
  // dark / light mode swap remains free.
  const accent = step.accent && h[step.accent] ? h[step.accent] : h.ac;

  return (
    <CoachMark
      key={i}
      target={step.target}
      title={step.title}
      body={step.body}
      placement={step.placement || "auto"}
      stepLabel={`Step ${i + 1} of ${steps.length}`}
      isFirst={i === 0}
      isLast={i >= steps.length - 1}
      onNext={next}
      onBack={back}
      onSkip={onSkip}
      h={h}
      accent={accent}
    />
  );
}
